(function() {
  'use strict';

  angular
    .module('factories.documentService', [])
    .factory('DocumentService', DocumentService);

  DocumentService.$inject = ['$http', 'ServiceHelper'];

  function DocumentService($http, ServiceHelper) {
    var url = {
      session: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/frame/:frameId/:action'
    };

    var keys = ['ipad', 'cModuleId', 'frameId', 'action'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key];
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    function createSession(cModuleId, frameId, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        frameId: frameId,
        action: 'CreateSession'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.get(createUrl(url.session, urlParams)),
          resultCb, errorCb);
      });
    }

    return {
      createSession: createSession
    };
  }
})();
